module.exports = __webpack_public_path__ + "static/the-talent-behind-disney-communications-social-54ede041d14cb55f54c245c2e877b393.jpg";